import React from 'react'
import { Routes, Route } from 'react-router-dom';
//! Constants
import { Base_API } from '../_actions/matcher'
//! Pages
import Appointment_2 from '../pages/appointment_2/index'
import Appointment_3 from '../pages/appointment_3/index'
import Appointment_4 from '../pages/appointment_4/index'
import Appointment_5 from '../pages/appointment_5/index'
import Packages from '../pages/packages/index'
import EndCampaign from '../pages/EndCampaign/inex';
import AppointHistoryDetails from '../pages/AppointHisDetails';
import ReAppointment_1 from '../pages/Re_appointment_1';
import ReAppointment_2 from '../pages/Re_appointment_2';
import ReAppointment_3 from '../pages/Re_appointment_3';
// New Flow
import Welcome_Card_Register from '../pages/Welcome_Card_Register';
import Agreement_Card_Register from '../pages/Agreement_Card_Register';
import Form_Card_Register from '../pages/Form_Card_Register';
import OTP from '../pages/OTP';
import Register_Card_Success from '../pages/Success';
import Login_Destination from '../pages/Login_Destination';
import MyCard from '../pages/MyCard';
import CardPointHistory from '../pages/CardPointHistory';
import Card_EditProfile from '../pages/Card_EditProfile';
import Card_MoreInfo from '../pages/Card_MoreInfo';
import AppointHistory from '../pages/AppointHis';
import AppointLists from '../pages/AppointLists';
import Edit_Appointment from '../pages/EditAppointment';
import ReceiveSVBranch_Success from '../pages/RecieveSvBranch_Success';
import ReceiveSVHome_Success from '../pages/RecieveSvHome_Success';
import EditUser_Appointment from '../pages/EditUser_Appointment';
import ContactUs from '../pages/ContactUs';
import RewardLists from '../pages/RewardLists';
import MyReward from '../pages/MyReward';
import Redeem_Success_Detail from '../components/Redeem_Success_Detail';
import MyBasket from '../pages/MyBasket';
import ConfirmOrder from '../pages/Confirm_Order';
import CFOD_EditContact from '../pages/CFOD_EditContact';
import CFOD_MyCoupons from '../pages/CFOD_MyCoupons';
import NH_Services from '../pages/NH_Services';
import CFOD_Payment from '../pages/CFOD_Payment';
import CFOD_PaymentSuccess from '../pages/CFOD_PaymentSuccess';
import PackageDetail from '../pages/PackageDetail';
import NH_Services_Detail from '../pages/NH_Services_Detail';
import MyBasket_NhServices from '../pages/MyBasket_NhServices';
import Confirm_Order_NhServices from '../pages/Confirm_Order_NhServices';
import InviteFriends from '../pages/InviteFriends';
import InviteeWelcome from '../pages/InviteeWelcome'; 
import RedeemReward_Success_Detail from '../components/RedeemReward_Success_Detail';
import RedirectPackages from '../pages/RedirectPackages';
import Edit_Appointment_Delivery from '../pages/EditAppointmentDelivery';
import ReceiveSVDelivery_Success from '../pages/RecieveSvHome_Success';
import SignIn_Policy from '../pages/SignIn_Policy';
import SignIn_Connection from '../pages/SignIn_Connection';
import SignIn_CheckMember from '../pages/SignIn_CheckMember';
import SignIn_Overview from '../pages/SignIn_Overview';
import SignIn_PrivacyPolicy from '../pages/SignIn_PrivacyPoilcy';
import SignUp_Overview from '../pages/SignUp_Overview';
import SignUp_ScanCard from '../pages/SignUp_ScanCard';
import SignUp_ScanFace from '../pages/SignUp_ScanFace';
import SignUp_FormInfo from '../pages/SignUp_FormInfo';
import SignUp_OTP from '../pages/SignUp_OTP';
import SignUp_Connection from '../pages/SignUp_Connection';
import SignUp_Success from '../pages/SignUp_Success';
import KYC_Overview from '../pages/KYC_Overview';
import KYC_Identity_Verified from '../pages/KYC_Identity_Verified';
import KYC_Step_1 from '../pages/KYC_Step_1';
import KYC_Step_2 from '../pages/KYC_Step_2';
import KYC_Step_3 from '../pages/KYC_Step_3';
import KYC_Step_4 from '../pages/KYC_Step_4';
import Primo from '../pages/Primo'
//! Components
import SignIn_Navbar from '../components/SignIn_Navbar';
//! Private Route
import PrivateRoute from '../_layout/PrivateRoute';
import UpdateKYC_Success from '../pages/UpdateKYC_Success';
import SignIn_OTP from '../pages/SignIn_OTP';
import SignIn_ConnectVerify from '../pages/SignIn_ConnectVerify';
import KYC_TESTUPDATE from '../pages/KYC_TESTUPDATE';
import Test from '../pages/Test';
import PrimoInitDest from '../pages/PrimoInitDest';
import { SessionChecker } from '../utils/addon/sessionChecker';

SessionChecker();

export function Routing() {
    return (
        <Routes>
            {/* Nhealth Card */}
            {/* - check endpoint เพื่ิอที่จะส่งไปหน้า register หรือ login */}
            <Route exact path={`${Base_API.pathWeb}/n-health/login-destination`}  element={<Login_Destination/>} />
            {/* - register card */}
            {/* <Route exact path={`${Base_API.pathWeb}/n-health/welcome-card-register`} element={<Welcome_Card_Register/>} /> */}
            {/* - agreement register card */}
            {/* <Route exact path={`${Base_API.pathWeb}/n-health/agreement-card-register`} element={<Agreement_Card_Register/>} /> */}
            {/* - form register card */}
            <Route exact path={`${Base_API.pathWeb}/n-health/form-card-register`} element={<Form_Card_Register/>} />
            {/* - otp */}
            <Route exact path={`${Base_API.pathWeb}/n-health/otp/:fromPage`} element={<OTP/>} />
            {/* - register card success */}
            {/* <Route exact path={`${Base_API.pathWeb}/n-health/register-card/success`} element={<Register_Card_Success/>} /> */}
            {/* - my card */}
            <Route exact path={`${Base_API.pathWeb}/n-health/mycard`} element={<MyCard/>} />
            {/* - invite friends */}
            <Route exact path={`${Base_API.pathWeb}/n-health/mycard/invite-friends`} element={<InviteFriends/>} />
            {/* - invitee welcome */}
            <Route exact path={`${Base_API.pathWeb}/n-health/inviteewelcome/:inviterID`}  element={<InviteeWelcome/>} />
            {/* - point history */}
            <Route exact path={`${Base_API.pathWeb}/n-health/mycard/point-history`} element={<CardPointHistory/>} />
            {/* - edit profile */}
            {/* <Route exact path={`${Base_API.pathWeb}/n-health/mycard/edit-profile`} element={<Card_EditProfile/>} />  */}
            {/* - card more information */}
            <Route exact path={`${Base_API.pathWeb}/n-health/mycard/more-information`} element={<Card_MoreInfo/>} /> 

            {/* Appoint History */}
            <Route exact path={`${Base_API.pathWeb}/n-health/appointHistory`} element={<AppointHistory/>} />

            {/* Appoint List */}
            <Route exact path={`${Base_API.pathWeb}/n-health/appointLists`} element={<AppointLists/>} /> 
            {/* - edit appointment */}
            <Route exact path={`${Base_API.pathWeb}/n-health/edit-appointment/:hisid/:campaignID`} element={<Edit_Appointment/>} />
            {/* - edit appointment (delivery) */}
            <Route exact path={`${Base_API.pathWeb}/n-health/edit-appointment-delivery/:hisid/:campaignID`} element={<Edit_Appointment_Delivery/>} />
            {/* - appoinement (receive service at branch) */}
            <Route exact path={`${Base_API.pathWeb}/n-health/receive-branch-success`} element={<ReceiveSVBranch_Success/>} />
            {/* - appoinement (receive service at home) */}
            <Route exact path={`${Base_API.pathWeb}/n-health/receive-home-success`} element={<ReceiveSVHome_Success/>} />
            {/* - appoinement (receive service at delivery) */}
            <Route exact path={`${Base_API.pathWeb}/n-health/receive-delivery-success`} element={<ReceiveSVDelivery_Success/>} />

            {/* Edit User Appointment */}
            <Route exact path={`${Base_API.pathWeb}/n-health/edit-user-appointment/:hisid/:campaignID`} element={<EditUser_Appointment/>} />

            {/* Contact Us */}
            <Route exact path={`${Base_API.pathWeb}/n-health/contact-us`} element={<ContactUs/>} />

            {/* Reward */}
            {/* - reward lists */}
            <Route exact path={`${Base_API.pathWeb}/n-health/reward-lists`} element={<RewardLists/>} /> 
            {/* - redeem success detail (Redeem Coupon Detail) */}
            <Route exact path={`${Base_API.pathWeb}/n-health/redeem-detail`} element={<Redeem_Success_Detail/>} /> 
            {/* - redeem success detail (Redeem Reward Detail) */}
            <Route exact path={`${Base_API.pathWeb}/n-health/redeemreward-detail`} element={<RedeemReward_Success_Detail/>} /> 
            {/* - my reward */}
            <Route exact path={`${Base_API.pathWeb}/n-health/my-reward`} element={<MyReward/>} />

            {/* Package List & Order System */}
            {/* <Route exact path={`${Base_API.pathWeb}/n-health/packages/`} element={<RedirectPackages/>} /> */}
            <Route exact path={`${Base_API.pathWeb}/n-health/packages/:ref`} element={<Packages/>} />
            {/* Package Detail */}
            <Route exact path={`${Base_API.pathWeb}/n-health/package-detail/:packID/:ref`} element={<PackageDetail/>} />
            {/* - nhealth services */}
            <Route exact path={`${Base_API.pathWeb}/n-health/nh-services/:ref`} element={<NH_Services/>} />
            {/* - nhealth services detail */}
            <Route exact path={`${Base_API.pathWeb}/n-health/nh-services-detail/:packID/:ref`} element={<NH_Services_Detail/>} />
            {/* - my basket (NH Services) */}
            <Route exact path={`${Base_API.pathWeb}/n-health/my-basket-nhservices/:ref`} element={<MyBasket_NhServices/>} />
            {/* - confirm order (NH Services) */}
            <Route exact path={`${Base_API.pathWeb}/n-health/confirm-order-nhservices/:ref`} element={<Confirm_Order_NhServices/>} />
            {/* - my basket */}
            <Route exact path={`${Base_API.pathWeb}/n-health/my-basket/:ref`} element={<MyBasket/>} />
            {/* - confirm order */}
            <Route exact path={`${Base_API.pathWeb}/n-health/confirm-order/:ref`} element={<ConfirmOrder/>} />
            {/* - edit contact inform */}
            <Route exact path={`${Base_API.pathWeb}/n-health/order/edit-contact-inform/:cameFrom/:ref`} element={<CFOD_EditContact/>} />
            {/* - my coupons */}
            <Route exact path={`${Base_API.pathWeb}/n-health/confirm-order/coupons/:cameFrom/:ref`} element={<CFOD_MyCoupons/>} />
            {/* - payment */}
            <Route exact path={`${Base_API.pathWeb}/n-health/order/payment/:type/:ref`} element={<CFOD_Payment/>} />
            {/* - payment success */}
            <Route exact path={`${Base_API.pathWeb}/n-health/confirm-order/payment/success/:ref`} element={<CFOD_PaymentSuccess/>} />

            <Route exact path={`${Base_API.pathWeb}/n-health/appointHistoryDetails/:tranid`} element={<AppointHistoryDetails/>} />
            {/* Page 1 */}
            {/* Page 2 */}
            <Route exact path={`${Base_API.pathWeb}/n-health/form/2/:randomNumber`} element={<Appointment_2/>} />
            {/* Page 3 */}
            <Route exact path={`${Base_API.pathWeb}/n-health/form/3`} element={<Appointment_3/>} />
            {/* Page 4 */}
            <Route exact path={`${Base_API.pathWeb}/n-health/form/4`} element={<Appointment_4/>} />
            {/* Page 5 */}
            <Route exact path={`${Base_API.pathWeb}/n-health/form/5`} element={<Appointment_5/>} />
            {/* End Campaign */}
            <Route exact path={`${Base_API.pathWeb}/n-health/endcampaign`} element={<EndCampaign/>} />
            {/* Re Appointment */}
            <Route exact path={`${Base_API.pathWeb}/n-health/reappointment-1/:tranid/:appointId`} element={<ReAppointment_1/>} />
            <Route exact path={`${Base_API.pathWeb}/n-health/reappointment-2/:tranid/:appointId`} element={<ReAppointment_2/>} />
            <Route exact path={`${Base_API.pathWeb}/n-health/reappointment-3`} element={<ReAppointment_3/>} />

            {/* Single Sign-on */}
            <Route 
                path={`${Base_API.pathWeb}/n-health/signin/policy`}
                element={
                    <SignIn_Policy/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/signin/connection`}
                element={
                    <SignIn_Connection/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/signin/checkmember`}
                element={
                    <SignIn_CheckMember/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/signin/overview`}
                element={
                    <SignIn_Overview/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/:type/privacy-policy`}
                element={
                    <SignIn_PrivacyPolicy/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/signin/otp`}
                element={
                    <SignIn_OTP/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/signin/connect-verify`}
                element={
                    <SignIn_ConnectVerify/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/signin/success`}
                element={
                    <SignUp_Success/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/signup/overview`}
                element={
                    <SignUp_Overview/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/signup/idcard-ocr`}
                element={
                    <SignUp_ScanCard/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/signup/face-ocr`}
                element={
                    <SignUp_ScanFace/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/signup/forminfo`}
                element={
                    <SignUp_FormInfo/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/signup/otp`}
                element={
                    <SignUp_OTP/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/signup/connection`}
                element={
                    <SignUp_Connection/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/signup/success`}
                element={
                    <SignUp_Success/>
                } 
            />
            {/* KYC */}
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/kyc/overview-1`}
                element={
                    <KYC_Overview/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/kyc/overview-2`}
                element={
                    <SignUp_Overview/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/kyc/idcard-ocr`}
                element={
                    <SignUp_ScanCard/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/kyc/face-ocr`}
                element={
                    <SignUp_ScanFace/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/kyc/identity-verified`}
                element={
                    <KYC_Identity_Verified/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/kyc/step-1`}
                element={
                    <KYC_Step_1/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/kyc/step-2`}
                element={
                    <KYC_Step_2/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/kyc/step-3`}
                element={
                    <KYC_Step_3/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/kyc/step-4`}
                element={
                    <KYC_Step_4/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/kyc/success`}
                element={
                    <UpdateKYC_Success/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/kyc/testupdate`}
                element={
                    <KYC_TESTUPDATE/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/primo/:primoType`}
                element={
                    <Primo/>
                } 
            />
            <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/primo/initdest/:primoType`}
                element={
                    <PrimoInitDest/>
                } 
            />
            {/* <Route 
                exact 
                path={`${Base_API.pathWeb}/n-health/test`}
                element={
                    <Test />
                } 
            /> */}
        </Routes>
    )
}
